export const COUNTRIES: Record<string, string> = {
  AR: "Argentina",
  BO: "Bolivia",
  BR: "Brasil",
  CL: "Chile",
  CO: "Colombia",
  CR: "Costa Rica",
  EC: "Ecuador",
  GT: "Guatemala",
  MX: "México",
  PA: "Panamá",
  PE: "Perú",
  PY: "Paraguay",
  UY: "Uruguay",
  VE: "Venezuela",
  US: "Estados Unidos",
  ES: "España",
};

export const getCountryFlag = (countryCode?: string) => {
  if (!countryCode) return "";
  const code = countryCode.substring(0,2).toLowerCase();
  return `https://flagcdn.com/w40/${code}.png`;
};

export const getCountryLabel = (countryCode?: string) => {
  if (!countryCode) return "";
  return COUNTRIES[countryCode] || countryCode;
};
